<template>
  <div>
    <section class="my-16 px-4 max-w-screen-xl mx-auto">
      <h2>Nuestros Ponentes</h2>
      <SpeakersList />
      <div class="mt-8">
        <BaseButton :to="{ name: 'Speakers' }">Ver Listado Completo</BaseButton>
      </div>
    </section>

    <SpeakersModal v-if="showSpeakerModal" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import SpeakersList from '@/components/SpeakersList'
import SpeakersModal from '@/components/SpeakersModal'

export default {
  components: { SpeakersList, SpeakersModal },

  computed: {
    ...mapState('speakers', ['showSpeakerModal']),
  },

  mounted() {
    this.$store.dispatch('speakers/fetchSpeakersListHome')
  },
}
</script>
